import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MonthlyPaymentMode } from 'src/app/models/virtual-store/monthly-payment.model';
import { Service } from 'src/app/models/virtual-store/service.model';

@Component({
  selector: 'app-popup-complaint',
  templateUrl: './popup-complaint.component.html',
  styleUrls: ['./popup-complaint.component.scss']
})
export class PopupComplaintComponent implements OnInit {

  listadoSteps = [];
  claimType = "";
  claimNumber = "";
  mostrarTextoOsinergmin = false;
  mostrarAsociado = false;
  associatedClaimNumber = "";
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<any>) { }

  ngOnInit() {
    this.listadoSteps = this.data.listadoSteps;
    this.claimType = this.data.claimType;
    this.claimNumber = this.data.claimNumber;
    this.mostrarTextoOsinergmin = this.claimType === 'Queja' || this.claimType === 'Apelación';
    this.mostrarAsociado = this.claimType === 'Apelación' || this.claimType === 'Reconsideración';
    this.associatedClaimNumber = this.data.associatedClaimNumber;
  }

  cancel(){
    this.dialogRef.close();
  }

}
